import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// i18n must initialise before App renders so useTranslation has a
// configured i18next instance to read from. The init module also reads
// localStorage["admin.locale"] (falling back to navigator.language and
// finally "sv") so the UI starts in the right language.
import "@/i18n";
import "./index.css";

document.documentElement.classList.add("dark");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
